import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettingsComp, ISocialLinks} from '@app/feature/store-editor/components/layout/store-editor.interface';
import IStoreGetDetailsInterface = namespace.IStoreGetDetailsInterface;


@Component({
  selector: 'app-footer-setting',
  templateUrl: './footer-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class FooterSettingComponent implements OnInit {
  @Input() footer: ILayoutSettingsComp;
  @Input() socialLink: ISocialLinks;

  constructor() {
  }

  ngOnInit() {
  }

}
